var render, staticRenderFns
import script from "./BaseCheckboxList.vue?vue&type=script&lang=js"
export * from "./BaseCheckboxList.vue?vue&type=script&lang=js"
import style0 from "./BaseCheckboxList.vue?vue&type=style&index=0&id=3b596438&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b596438",
  null
  
)

export default component.exports